import { Component, computed, input } from '@angular/core';
import {
  AccountProvider,
  AdPlatform,
  AdPlatformType,
  HasAccountPlatform,
  Status,
} from '@app/core/models/common.models';

import { getPlatform, getPlatformLogo, getStatusFromAccount } from '@app/core/utilities/account.utilities';

@Component({
  selector: 'adspt-account-logo',
  templateUrl: './account-logo.component.html',
  styleUrls: ['./account-logo.component.scss'],
})
export class AccountLogoComponent {
  readonly account = input<HasAccountPlatform | AccountProvider | AdPlatform | AdPlatformType>();
  readonly showStatus = input<boolean>();
  readonly forceStatus = input<Status>();
  readonly invert = input<boolean>();

  readonly platform = computed(() => getPlatform(this.account()));
  readonly src = computed(() => getPlatformLogo(this.account(), this.invert()));
  readonly status = computed(() => this.forceStatus() || getStatusFromAccount(this.account()));
}
